import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
	selector: "app-confirm-dialog",
	templateUrl: "./input-dialog.component.html"
})
export class InputDialogComponent implements OnInit {
	placeholder: string;
	isSaving: boolean;
	smallFont: boolean;
	title: string | boolean;
	maxLength: number;
	textRequired;
	inputValue;

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: any,
		private DialogRef: MatDialogRef<InputDialogComponent>
	) { }

	ngOnInit(): void {
		this.smallFont = this.data.smallFont;
		this.title = this.data.title;
		this.placeholder = this.data.placeholder;
		this.inputValue = this.data.inputValue;
		this.textRequired = this.data.textRequired;
		this.maxLength = this.data.maxLength ? this.data.maxLength : 10000000000 ;
	}

	handleKeyUp(event): void {
		if (event.keyCode === 13) {
			this.confirm();
		}
	}

	confirm(): void {
		this.isSaving = true;
		this.DialogRef.disableClose = true;
		this.data.onConfirm(this.inputValue);
	}
	close(): void {
		this.DialogRef.close();
	}

	getValid(): boolean {
		if (this.textRequired === undefined || !this.textRequired) {
			return true;
		} else {
			return this.inputValue !== undefined && this.inputValue.trim() !== '';
		}
	}
}
